import ConvertServiceModal from "pages/future-medical/shared/right-sidebar/change-msa-type/ConvertServiceModal";
import { useState } from "react";

type ClickableServiceTypeProps = {
  serviceType: string;
  serviceId: string;
};

const ClickableServiceType = ({
  serviceType,
  serviceId,
}: ClickableServiceTypeProps) => {
  const [showModal, setShowModal] = useState(false);

  const handleClick = () => {
    setShowModal(true);
  };

  return (
    <>
      <span
        onClick={handleClick}
        style={{
          cursor: "pointer",
          textDecoration: "underline",
          color: "var(--color-primary)",
        }}
      >
        {serviceType}
      </span>

      {showModal && (
        <ConvertServiceModal
          serviceId={serviceId}
          currentServiceType={serviceType}
          isOpen={showModal}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ClickableServiceType;
